import React, { useEffect, useState } from 'react';
import { VStack, HStack } from 'native-base';
import {
    observer,
    GIFTCARD_FLOWS,
    i18nFn,
    useSpringBigStore,
    useGetGiftCardPaymentList,
    GiftCardPayment,
    useDeleteGiftCardPayment
} from '@springbig/shared';
import { useToast } from '~/hooks/toast';
import { Caption } from '~/shared/Typography';
import { Button } from '~/shared/Theme';

const ManagePayment = ({ t }: { t: i18nFn }) => {

    const { giftCardPaymentList, member } = useSpringBigStore();
    const giftCardPaymentListQuery = useGetGiftCardPaymentList();
    const [deleteList, setDeleteList] =
        useState<GiftCardPayment[]>([]);

    const onPayemendAddPress = () => {

        observer.emit('change-screen', GIFTCARD_FLOWS.addPayment);
    };

    useEffect(() => {

        giftCardPaymentListQuery?.refetch();
    }, []);

    const paymentCards = giftCardPaymentList?.filter(
        (payment: GiftCardPayment) => payment.card_nickname
    );

    const { mutate: deleteMethod } = useDeleteGiftCardPayment();
    const { errorToast, successToast } = useToast();

    const onSubmitPayment = (): void => {

        deleteList.forEach((selectedMethod) => {

            deleteMethod({
                id: selectedMethod?.id,
                member_id: member?.id,
            }, {
                onSuccess() {

                    successToast(t('giftCard.manage.success'));
                    giftCardPaymentListQuery?.refetch();
                },
                onError() {

                    errorToast(t('giftCard.manage.error'));
                }
            });
        });
    };

    return (
        <VStack space={8}>
            <Caption
                text={'payment.manage_payments'}
                textAlign={'center'}
                fontSize={24}
            />
            <HStack
                alignItems={'center'}
                justifyContent={'space-between'}
            >
                <Caption
                    text={'payment.cards_on_file'}
                    fontSize={18}
                />
                <Button
                    modifier={'small'}
                    text={'payment.new_card'}
                    onPress={onPayemendAddPress}
                />
            </HStack>
            {
                paymentCards &&
                paymentCards.length > 0 &&
                paymentCards.map((paymentMethod) => {

                    const { account_name, card_nickname } = paymentMethod;
                    const isDelete = !deleteList.includes(paymentMethod);

                    return (
                        <HStack
                            key={`${account_name || card_nickname}-${Math.random()}`}
                            alignItems={'center'}
                            flexWrap={'wrap'}
                            justifyContent={'space-between'}
                        >
                            <Caption fontSize={22} fontWeight={'200'}>
                                x{ account_name || card_nickname }
                            </Caption>
                            { paymentCards.length > 1 && isDelete &&
                                <Button
                                    variant={'danger'}
                                    text={'payment.remove'}
                                    onPress={() => setDeleteList([...deleteList, paymentMethod])}
                                />
                            }
                            { paymentCards.length > 1 && !isDelete &&
                                <Button
                                    text={'payment.add'}
                                    fontSize={18}
                                    onPress={() => setDeleteList([...(deleteList.filter((e) => e !== paymentMethod))])}
                                />
                            }
                        </HStack>
                    );
                })
            }
            <Button
                fontSize={18}
                text={'payment.save'}
                onPress={onSubmitPayment}
            />
        </VStack>
    );
};

export default ManagePayment;
